import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/**
 * The platform's page column. 90rem (1440px) rather than 72rem: at 72rem a
 * typical laptop showed a hand's width of empty wash down either side of the
 * marketing site. Reading matter (policies, sign-in forms) passes its own
 * narrower `max-w-*`.
 */
export function Container({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return <div className={cn('mx-auto w-full max-w-[90rem] px-5 sm:px-8 lg:px-10', className)}>{children}</div>;
}
